import axios from 'axios'
import _get from 'lodash/get'

export const PROPERTY_INCOME_GET = 'PROPERTY_INCOME_GET'
export const PROPERTY_INCOME_UPDATE = 'PROPERTY_INCOME_UPDATE'
export const PROPERTY_INCOME_SAVE = 'PROPERTY_INCOME_SAVE'
export const PROPERTY_INCOME_SAVING = 'PROPERTY_INCOME_SAVING'
export const PROPERTY_INCOME_SAVE_SUCCESS = 'PROPERTY_INCOME_SAVE_SUCCESS'
export const PROPERTY_INCOME_SAVE_ERROR = 'PROPERTY_INCOME_SAVE_ERROR'

export const getPropertyIncome = (selfAssessmentId) => (dispatch) => {
    axios
        .get(`/propertyincome/${selfAssessmentId}`)
        .then((response) => {
            const propertyIncome = { ...response.data, fetchSuccessful: true }

            dispatch(updatePropertyIncome(propertyIncome))
        })
        .catch((error) => {
            if (_get(error, ['response', 'status']) === 404) {
                dispatch(updatePropertyIncome({ fetchSuccessful: true }))
            }
        })
}

export const updatePropertyIncome = (propertyIncome) => ({
    type: PROPERTY_INCOME_UPDATE,
    propertyIncome,
})

export const savePropertyIncome = () => (dispatch, getState) => {
    const { assessment, propertyIncome } = getState()

    dispatch(propertyIncomeSaving, propertyIncome)

    axios
        .put(`/propertyincome/${assessment.id}`, { ...propertyIncome, selfAssessmentId: assessment.id })
        .then((response) => {
            dispatch(propertyIncomeSaveSuccess(response.data))
        })
        .catch((error) => {
            const existingPropertyIncome = { ...propertyIncome }
            dispatch(propertyIncomeSaveError(existingPropertyIncome, _get(error, ['response', 'data'])))
        })
}

export const updateAndSavePropertyIncome = (propertyIncome) => (dispatch) => {
    dispatch(updatePropertyIncome(propertyIncome))
    dispatch(savePropertyIncome())
}

export const propertyIncomeSaving = (propertyIncome) => ({
    type: PROPERTY_INCOME_SAVING,
    propertyIncome,
})

export const propertyIncomeSaveSuccess = (propertyIncome) => ({
    type: PROPERTY_INCOME_SAVE_SUCCESS,
    propertyIncome,
})

export const propertyIncomeSaveError = (propertyIncome, errorResponse) => ({
    type: PROPERTY_INCOME_SAVE_ERROR,
    propertyIncome,
    errorResponse,
})
